// extracted by mini-css-extract-plugin
export default {"Page2Main":"Page2_Page2Main__k4LDX","Page2Parent":"Page2_Page2Parent__FWr4K"};